import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../../auth';
import Swal from 'sweetalert2';
import { Button, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import Select from 'react-select';
import { axiosAuth } from '../../../../../api';

function ModalTambahRole({
    showTambahRole,
    setShowTambahRole,
    listDivisi,
    retrieveRole,
    accessToken
}) {

    const { theme } = useContext(ThemeContext);
    const [roleName, setRoleName] = useState('');
    const [selectedDivisi, setSelectedDivisi] = useState(null);
    const [listMenu, setListMenu] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowTambahRole(false);
        setRoleName('');
        setSelectedDivisi(null);
        setListMenu([]);
    };

    const divisiOptions = listDivisi.map(divisi => ({
        value: divisi.id,
        label: divisi.groupName,
    }));

    const handleSelectDivisi = selectedOption => {
        setSelectedDivisi(selectedOption);
    };

    const retrieveMenu = () => {
        axiosAuth.get(`/api/menus?groupId=${selectedDivisi?.value}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListMenu(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (selectedDivisi?.value !== undefined) retrieveMenu();

    }, [selectedDivisi?.value]);

    const [checkboxes, setCheckboxes] = useState({});

    useEffect(() => {
        const initialCheckboxes = listMenu.reduce((acc, menu, index) => {
            acc[index] = {
                canRead: false,
                canCreate: false,
                canUpdate: false,
                canDelete: false,
                semua: false,
            };
            return acc;
        }, {});
        setCheckboxes(initialCheckboxes);
    }, [listMenu]);

    const handleCheckboxChange = (event, rowIndex) => {
        const { id, checked } = event.target;

        setCheckboxes((prevCheckboxes) => {
            const updatedRow = {
                ...prevCheckboxes[rowIndex],
                [id]: checked,
            };

            if (id === 'canRead') {

                updatedRow.canCreate = checked
                updatedRow.canUpdate = checked
                updatedRow.canDelete = checked
                updatedRow.semua = checked;


                updatedRow.disabled = !checked;
            } else if (id === 'semua') {
                updatedRow.canRead = checked;
                updatedRow.canCreate = checked;
                updatedRow.canUpdate = checked;
                updatedRow.canDelete = checked;

                updatedRow.disabled = !checked;
            } else {
                updatedRow.semua =
                    updatedRow.canRead &&
                    updatedRow.canCreate &&
                    updatedRow.canUpdate &&
                    updatedRow.canDelete;


            }

            return {
                ...prevCheckboxes,
                [rowIndex]: updatedRow,
            };
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();


        // const dataPermissions = Object.entries(checkboxes).map(([index, values]) => {
        //     const { semua, ...filteredValues } = values;
        //     return {
        //         groupMenuId: listMenu[index]?.groupMenuId,
        //         ...filteredValues,
        //     };
        // });

        const data = {
            roleName: roleName,
            groupId: selectedDivisi?.value,
        };

        setIsSubmitting(true);
        setDisabled(true);

        try {

            const response = await axiosAuth.post(`/api/roles`, data, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Role',
                showConfirmButton: true,
            });
            retrieveRole();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);
            handleClose();
            if (err.response?.status === 400) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...!',
                    text: `${err.response?.data.message}`,
                })
                setIsSubmitting(false);
                setDisabled(false);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat menambahkan Role',
                });
                setIsSubmitting(false);
                setDisabled(false);
            }
        } finally {

            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (
        <Modal
            show={showTambahRole}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Tambah Role
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='divisi'>Divisi*</Form.Label>
                        <Select
                            id='divisi'
                            options={divisiOptions}
                            value={selectedDivisi}
                            onChange={handleSelectDivisi}
                            placeholder='Pilih Divisi'
                            styles={selectStyles}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='roleName'>Nama Role*</Form.Label>
                        <Form.Control
                            id='roleName'
                            type="text"
                            onChange={(e) => setRoleName(e.target.value)}
                            value={roleName}
                            required
                            placeholder="Masukkan nama role"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={
                                    disabled ||
                                    !selectedDivisi ||
                                    !roleName
                                }
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalTambahRole
